import { render } from "./course-information.vue?vue&type=template&id=56fe5963"
import script from "./course-information.vue?vue&type=script&lang=js"
export * from "./course-information.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__